import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Text } from '@chakra-ui/react';
import { ChevronRight, LocalShippingOutlined, AssignmentReturnOutlined, LockOutlined } from '@mui/icons-material';

import FloatingDrawer from './FloatingDrawer';

// Account drawer: links when logged in, log in / create account otherwise
const AccountDrawer = ({ isOpen, onClose, user, links, onLogout }) => {

    const navigate = useNavigate();
    const go = (path) => { onClose(); navigate(path); };

    return (
        <FloatingDrawer isOpen={isOpen} onClose={onClose} title={user ? `Hi, ${user.firstName}` : 'My account'} width='420px' label='Account' >
            <Box px={{ base: '16px', md: '20px' }} py='8px' >
                {user ? (
                    <>
                        {links.map(l => (
                            <Box key={l.path} as='button' width='100%' display='flex' alignItems='center' justifyContent='space-between' py='16px' borderBottom='1px solid' borderColor='raano.border' fontSize='15px' onClick={() => go(l.path)} >
                                {l.label}<ChevronRight sx={{ fontSize: 20 }} />
                            </Box>
                        ))}
                        <Button mt='24px' width='100%' variant='wipe' height='48px' fontSize='16px' onClick={() => { onClose(); onLogout(); }} >Log out</Button>
                    </>
                ) : (
                    <>
                        <Text mt='16px' fontSize='26px' fontWeight={700} textTransform='uppercase' sx={{ fontStretch: '75%' }} lineHeight={1.05} >Welcome to Raano</Text>
                        <Text mt='8px' fontSize='14px' color='raano.muted' >Log in to see your orders, save your wishlist and check out faster.</Text>
                        <Button mt='20px' width='100%' variant='ink' height='48px' fontSize='16px' onClick={() => go('/login')} >Log in</Button>
                        <Button mt='10px' width='100%' variant='wipe' height='48px' fontSize='16px' onClick={() => go('/register')} >Create account</Button>
                        <Box mt='28px' borderTop='1px solid' borderColor='raano.border' >
                            {[[LocalShippingOutlined, 'Free delivery on every order'], [AssignmentReturnOutlined, '30-day returns and exchanges'], [LockOutlined, 'Secure payments: UPI, cards, netbanking']].map(([Icon, text]) => (
                                <Box key={text} display='flex' alignItems='center' gap='12px' py='14px' borderBottom='1px solid' borderColor='raano.border' fontSize='14px' ><Icon sx={{ fontSize: 20 }} />{text}</Box>
                            ))}
                        </Box>
                    </>
                )}
            </Box>
        </FloatingDrawer>
    );
};

export default AccountDrawer;
